import { MainTemplate } from "@/components/templates";
import {
  ConnectBoardProvisionalRegistrationForm,
  ConnectBoardProvisionalRegistrationFormValues,
} from "@/components/organisms";
import {
  RegisterProvisionalCompanyWithConnectBoardMutation,
  useRegisterProvisionalCompanyWithConnectBoardMutation,
} from "@/generated/graphql";
import React from "react";
import { useRouter } from "next/router";
import { PageTitle } from "@/components/molecules";
import useRollbarUtil from "../hooks/useRollbarUtil";

export const ConnectBoardProvisionalRegistrationPage = () => {
  const { getNotifyErrorHandlerForGraphQL } = useRollbarUtil();
  const router = useRouter();
  const { app, code } = router.query;

  const [registerProvisionalCompanyUserWithConnectBoardMutation] =
    useRegisterProvisionalCompanyWithConnectBoardMutation({
      onCompleted: (
        data: RegisterProvisionalCompanyWithConnectBoardMutation
      ) => {
        if (data.registerProvisionalCompanyWithConnectBoard) {
          router.push("/connect-biz/provisional-registration-result");
        }
      },
      onError: getNotifyErrorHandlerForGraphQL(
        "Faild to register provisional company user with connect board",
        "登録に失敗しました"
      ),
    });

  const handleSubmit = async (
    formValues: ConnectBoardProvisionalRegistrationFormValues
  ) => {
    await registerProvisionalCompanyUserWithConnectBoardMutation({
      variables: {
        input: {
          email: formValues.email,
          app: app ? String(app) : "",
          registrationCode: code ? String(code) : "",
        },
      },
    });
  };

  return (
    <MainTemplate title="新規登録">
      <PageTitle
        mainTitle={`新規登録`}
        subTitle={
          <>
            Mikatano シリーズの各サービスに共通でログインできるMikatano
            IDを作成します。
            <br />
            メールアドレスを入力し利用規約に同意して登録してください。
          </>
        }
      />
      <ConnectBoardProvisionalRegistrationForm onSubmit={handleSubmit} />
    </MainTemplate>
  );
};
